import React, {useEffect, useRef, useState} from 'react';
import {Button, Col, Container, Row, Image} from 'react-bootstrap';
import QrScanner from 'qr-scanner';
import '../App.css';
import logo from '../assets/logo_uct.png';
import {useNavigate} from 'react-router-dom';
import {Usuario} from '../interfaces/usuarios';
import axios from 'axios';
import {TbLogout2} from 'react-icons/tb';
import CryptoJS from 'crypto-js';
import getChileanTime from '../utils/time';

const Home: React.FC<{
	setUsuario: Function;
	setRegistro: Function;
	setIsLoggedIn: Function;
}> = ({setUsuario, setRegistro, setIsLoggedIn}) => {
	const videoRef = useRef<HTMLVideoElement | null>(null);
	const [scannerActive, setScannerActive] = useState(true);
	const navigate = useNavigate();

	const handleQRCode = async (
		result: string,
		setRegistro: Function,
		setUsuario: Function,
		navigate: Function,
		setScannerActive: Function,
	) => {
		setScannerActive(false); // Deshabilitar el escáner

		const [email, registro, time, key] = result.split(';');
		if (!email || !registro || !time || !key) {
			alert('Error: datos del QR malformados');
			setScannerActive(true); // Volver a habilitar el escáner
			return;
		}
		setRegistro(registro);

		// Desencriptar time con key usando AES algoritmo en modo ECB y padding PKCS7
		const llave = CryptoJS.enc.Utf8.parse(key);
		const bytes = CryptoJS.AES.decrypt(time, llave, {
			mode: CryptoJS.mode.ECB,
			padding: CryptoJS.pad.Pkcs7,
		});
		const plaintext = bytes.toString(CryptoJS.enc.Utf8);

		if (!plaintext) {
			alert('Error de desencriptación: datos malformados');
			setScannerActive(true); // Volver a habilitar el escáner
			return;
		}

		try {
			const dateInChile = await getChileanTime();
			const new_time = new Date(dateInChile).getTime();
			const old_time = new Date(plaintext).getTime();

			if (new_time - old_time > 30000) {
				alert('Error: QR de credencial expirado');
				setScannerActive(true); // Volver a habilitar el escáner
				return;
			} else if (new_time - old_time < 0) {
				alert(
					'Error: QR de credencial con fecha futura, revise la hora de su dispositivo',
				);
				setScannerActive(true); // Volver a habilitar el escáner
				return;
			} else {
				const response = await axios.get(
					'https://api-credencialestudiantes.uct.cl/datosUsuario',
					{
						params: {email},
						timeout: 2500,
					},
				);
				const data = response.data.data;
				if (data.length > 0) {
					setUsuario(data as Usuario[]);
					navigate('/validacion');
				}
			}
		} catch (error) {
			alert(
				'Error al obtener la hora de Chile o en la solicitud: ' +
					(error as Error).message,
			);
		} finally {
			setScannerActive(true); // Volver a habilitar el escáner
		}
	};

	useEffect(() => {
		let qrScanner: QrScanner | null = null;
		if (videoRef.current) {
			qrScanner = new QrScanner(
				videoRef.current,
				(result) => {
					if (scannerActive) {
						handleQRCode(
							result.data,
							setRegistro,
							setUsuario,
							navigate,
							setScannerActive,
						);
					}
				},
				{
					onDecodeError: (error) => {
						return;
					},
				},
			);

			qrScanner.start().catch((error) => {
				// console.error('Error al iniciar el escáner QR:', error);
				window.location.reload();
			});
		}
		return () => {
			if (qrScanner) {
				qrScanner.stop();
			}
		};
	}, [videoRef, setRegistro, navigate, setUsuario, scannerActive]);

	return (
		<>
			<Row className='pb-4 pe-5 me-5'>
				<Col className='d-flex justify-content-start ms-3'>
					<Button
						className='button mt-4 ms-4'
						onClick={() => {
							setIsLoggedIn(false);
							navigate('/login');
						}}>
						<TbLogout2 className='me-2' />
						Cerrar sesión
					</Button>
				</Col>
				<Col className='d-flex justify-content-start mt-3 me-5 pe-5'>
					<Image
						className='mt-2'
						src={logo}
						style={{width: 'auto', height: '60px'}}
					/>
				</Col>
			</Row>
			<Container>
				<Row>
					<Col className='d-flex justify-content-center'>
						<span className='titulo-custom pb-4'>
							Módulo de validación de credencial virtual
						</span>
					</Col>
				</Row>
				<Row>
					<Col className='d-flex justify-content-center'>
						<div className='qr-reader-container'>
							<video className='qr-reader' ref={videoRef} />
						</div>
					</Col>
				</Row>
			</Container>
		</>
	);
};

export default Home;
